<template>
  <div class="reviews-root pb-20">

    <SplashVideo class="mb-20 px-8" />
    <SplashFeatures class="px-8" />
    <Ribbon class="mb-20" />
    <div class="max-w-7xl mx-auto mb-20 px-8">
      <SampleHr class="mb-20" />
      <WhatYouGet />
    </div>
    <SuiteOfPower class="mb-20" />
    <LowPrices />
    <div class="flex justify-center">
      <RegistrationPrompt
        button-id="company-size-button"
        class="mx-auto shadow-md"
      />
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onBeforeMount,
  useMeta,
} from '@nuxtjs/composition-api';
import SampleHr from '../SampleHr.vue';
import SuiteOfPower from './SuiteOfPower.vue';
import LowPrices from './LowPrices.vue';
import RegistrationPrompt from '@/components/RegistrationPrompt.vue';
import Ribbon from '@/components/Ribbon.vue';
import WhatYouGet from '@/components/WhatYouGet.vue';
import SplashVideo from '@/modules/SplashPage/components/SplashVideo.vue';
import SplashFeatures from '@/modules/SplashPage/components/SplashFeatures.vue';
import useGlobalSettings from '@/hooks/useGlobalSettings';

export default defineComponent({
  name: 'ReviewsRoot',
  components: {
    RegistrationPrompt,
    Ribbon,
    WhatYouGet,
    SplashVideo,
    SplashFeatures,
    SampleHr,
    SuiteOfPower,
    LowPrices,
  },
  setup() {
    const title = `Finally... 5-star HR Service for Small Business Owners!`;
    const subtitle = `"Bambee, Where have you been all my life! All those sleepless nights researching laws and compliance rules. All those times I questioned if I was doing the right thing. You have taken my hand and given me confidence that I'm doing the right thing by my team and it's taken a load of stress away!" - Emily`;
    const headerImage = `/assets/information/reviews/5stars.svg`;

    const { setHeader } = useGlobalSettings();

    onBeforeMount(() => {
      setHeader({
        header: title,
        subheader: subtitle,
        headerImage,
        heroImage: null,
        metaTitle: `Reviews`,
        registration: true,
        noHero: false,
      });
    });

    useMeta(() => ({ title }));

    return {
      title,
      subtitle,
    };
  },
  head() {},
});
</script>
